import { Amplify } from "aws-amplify";

export const userPoolId = process.env.REACT_APP_AWS_USER_POOL_ID || "";
export const region = process.env.REACT_APP_AWS_COGNITO_REGION || "";
export const userPoolClientId =
  process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID || "";
export const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN || "";
export const cognitoIdentityPoolId =
  process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID || "";

// Amplify configuration for Cognito
export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: userPoolId,
      userPoolClientId: userPoolClientId,
      identityPoolId: cognitoIdentityPoolId,
      loginWith: {
        oauth: {
          domain: cognitoDomain,
          scopes: ["openid", "email", "profile"],
          redirectSignIn: [`${window.location.origin}/callback`],
          redirectSignOut: [`${window.location.origin}/logout`],
          responseType: "code" as const,
          // Google and other social providers will be available if configured in Cognito User Pool
          // The providers are automatically detected from the Cognito configuration
        },
        email: true,
        username: true,
      },
    },
  },
};

// Initialize Amplify
Amplify.configure(amplifyConfig);
